import { getData } from "../webApi"

export async function findCustomerAccountsByCustomerIdAndCustomerAccountTypeTargetProductId(customerId, targetProductId, includeBalances = false, includeProductDescription = false) {
    const { success, data } = await getData('/lookup/customerAccount/find-customer-accounts-by-customer-id-and-customer-account-type-target-product-id', { customerId, targetProductId, includeBalances, includeProductDescription }, false)
    if (success) {
        return data?.result
    }

    return null
}